import React, { useState } from 'react';
import Header from '../../../header/header';
import Navvbar from '../../../header/Navvbar';

const AccountQuickCodes = () => {
  // State to track hover for the data row
  const [isHovered, setIsHovered] = useState(false);

  // Details heading ka style
  const detailsHeaderStyle = {
    color: '#004aad',
    marginBottom: '10px',
    marginLeft:'35px'
  };

  // Grey container ka main style (SIRF HEADERS KE LIYE)
  const containerStyle = {
    backgroundColor: '#f4f4f4',
    padding: '10px',
    borderTop: '2px solid #004aad',
    marginLeft:'35px'
  };

  // Headers wali row ka style
  const headerRowStyle = {
    display: 'flex',
    fontWeight: 'bold',
  };

  // Data row ka style (hover ke sath)
  const dataRowStyle = {
    display: 'flex',
    padding: '10px',
    borderBottom: '1px solid #eeeeee',
    backgroundColor: isHovered ? '#f4f4f4' : '#ffffff', // Hover pe grey, normal pe white
    transition: 'background-color 0.3s ease', // Smooth transition for hover
    marginLeft:'35px'
  };

  // "Quick Code" column ka style
  const quickCodeStyle = {
    width: '150px',
  };

  // "Account" column ka style
  const accountStyle = {
    // Yeh baqi bachi hui jagah le lega
  };

  return (
    <div>
        <Header/>
        <Navvbar/>
      <h1 style={{marginLeft:'35px'}}>Account Quick Codes</h1>
      <h2 style={detailsHeaderStyle}>Details</h2>

      {/* Main container (SIRF HEADER) */}
      <div style={containerStyle}>
        <div style={headerRowStyle}>
          <div style={quickCodeStyle}>Quick Code</div>
          <div style={accountStyle}>Account</div>
        </div>
      </div>

      {/* Data row with hover effect */}
      <div
        style={dataRowStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={quickCodeStyle}>22530</div>
        <div style={accountStyle}>Dominica Bridge Street Dental Practice</div>
      </div>
      <div style={{ backgroundColor: '#f4f4f4', padding: '10px' ,marginLeft:'35px'}}></div>
    </div>
  );
};

export default AccountQuickCodes;